import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  // Select,
} from "@mui/material";
import { setIsLoading } from "../../../features/datatable/dataTableSlice";
import {
  getHeaders,
  createAnalysis,
} from "../../../utils/computation/analysis";
import { getColumnValuesWithZero } from "../../../utils/computation/getColumnValuesWithZero";
import { getBoxPlotGroup } from "../../../utils/computation/getBoxPlotGroup";
import { getMultiVariableBoxPlotGroup } from "../../../utils/computation/getMultiVariableBoxPlotGroup";
import { getHistogramGroup } from "../../../utils/computation/getHistogramGroup";
import { getIndividualPlot } from "../../../utils/computation/getIndividualPlot";
import { getHistogramGroupWithDistribution } from "../../../utils/computation/getHistogramGroupWithDistribution";
import Dropdown from "../../Dropdown";

const style = {
  // display: "flex",
  // justifyContent: "center",
  // alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  backgroundColor: "white",
  padding: "48px",
  borderRadius: "15px",
  maxHeight: "90vh",
  // boxSizing: "content-box",
  overflow: "hidden",
  "&:hover": { overflowY: "scroll" },
};

// const colors = ["Blue", "Green", "Red", "Cyan", "Magenta", "Yellow"];

const BoxPlotVariableInput = ({
  value,
  onChange,
  inputNumber,
  options,
  onChangeTitle,
}) => {
  const titleArray = ["(Y)", "(X)"];
  return (
    <>
      {inputNumber === 0 && (
        <Grid item xs={12} sm={12} md={12} sx={{ marginTop: "16px" }}>
          <h3>Title</h3>
          <TextField
            fullWidth
            id="filled-basic"
            variant="filled"
            label="Title"
            onChange={onChangeTitle}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={12} sx={{ marginTop: "16px" }}>
        <h3> Array {inputNumber + 1 + " " + titleArray[inputNumber]} </h3>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
          <Dropdown
            labelId="histogram-group-select-label"
            id="histogram-group-select"
            value={value}
            onChange={onChange}
            options={options}
          />
        </FormControl>
      </Grid>
    </>
  );
};

const BoxPlotVariableInputGroup = ({
  value,
  onChange,
  inputNumber,
  options,
}) => {
  return (
    <>
      <Grid item xs={12} sm={12} md={12} sx={{ marginTop: "16px" }}>
        <h3> Array {inputNumber + 1} </h3>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
          <Dropdown
            labelId="histogram-group-select-label"
            id="histogram-group-select"
            value={value}
            onChange={onChange}
            options={options}
          />
        </FormControl>
      </Grid>
    </>
  );
};

const HistogramVariableInput = ({
  value,
  valueLegend,
  onChange,
  inputNumber,
  options,
  onColorChange,
}) => {
  return (
    <>
      <Grid item xs={6} sm={6} md={6} sx={{ marginTop: "16px" }}>
        <h3> Variable {inputNumber + 1}</h3>
        <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
          <Dropdown
            labelId="histogram-group-select-label"
            id="histogram-group-select"
            value={value}
            onChange={onChange}
            options={options}
          />
        </FormControl>
      </Grid>

      <Grid item xs={6} sm={6} md={6}>
        <h3>Enter Legend {inputNumber + 1}</h3>
        <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
          {/* <Dropdown
            labelId="histogram-colors-select-label"
            id="histogram-colors-select"
            onChange={onColorChange}
            options={colors}
          /> */}
          <TextField
            fullWidth
            id="histogram-colors-select"
            variant="filled"
            labelId="histogram-colors-select-label"
            value={valueLegend}
            onChange={onColorChange}
          />
        </FormControl>
      </Grid>
    </>
  );
};

const MultipleVariableModal = ({
  title,
  closeMenu,
  openModal,
  setOpenModal,
}) => {
  //local states
  const [numberOfColumns, setNumberOfColumns] = useState(2);
  const [selectedColumns, setSelectedColumns] = useState(["", ""]);
  const [selectedColors, setSelectedColors] = useState(["", ""]);
  const [selectedTitles, setSelectedTitles] = useState(["", ""]);

  const [array1Title, setarray1Title] = useState("");
  const [array2Title, setarray2Title] = useState("");
  const [newTitle, setnewTitle] = useState("");
  const [yAxis, setYAxis] = useState("");
  const [xTickTitle, setxTickTitle] = useState("");

  const [yLabel, setyLabel] = useState("");
  const [xLabel, setxLabel] = useState("");

  const [isFit, setIsFit] = useState(false);

  //params
  const { documentId } = useParams();
  //dispatch
  const dispatch = useDispatch();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions
  const handleColumnSelectChange = (event, i) => {
    setSelectedColumns((oldArray) => {
      return oldArray.map((item, indexInOldArray) => {
        return indexInOldArray === i ? event.target.value : item;
      });
    });
  };

  const addVariableInput = () => {
    setSelectedColumns((v) => [...v, ""]);
    setNumberOfColumns((v) => v + 1);
    setSelectedColors((v) => [...v, ""]);
    setSelectedTitles((v) => [...v, ""]);
  };

  const handleChangeColor = (event, i) => {
    setSelectedColors((oldArray) => {
      return oldArray.map((item, indexInOldArray) => {
        return indexInOldArray === i ? event.target.value : item;
      });
    });
  };

  const handleChangeLegend = (event, i) => {
    // console.log(event.target.value);
    return event.target.value;
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    closeMenu();
    setOpenModal(false);
  };

  const createGraph = async () => {
    dispatch(setIsLoading());
    const value = selectedColumns
      .filter((col) => col !== "")
      .map((col) => getColumnValuesWithZero(data, col));

    const header = selectedColumns
      .filter((col) => col !== "")
      .map((col) => {
        let head = getHeaders(data, col);
        return head[0];
      });

    const array2 = getColumnValuesWithZero(data, yAxis);
    const array2Title = getHeaders(data, yAxis);

    // return console.log("value", value);
    if (value.length < 2) {
      dispatch(setIsLoading());
      return closeMenu();
    }

    let graphResult;
    if (title === "Multi Variable Boxplot (Group)") {
      const res = await getMultiVariableBoxPlotGroup(
        value,
        header,
        newTitle,
        array2,
        array2Title
      );

      if (!res) return;

      graphResult = {
        ...res,
        column: selectedColumns.join(", "),
        title,
      };
    }

    if (title === "Multi Variable Boxplot (Ungroup)") {
      const { inputs, ...rest } = await getBoxPlotGroup(
        value,
        header,
        newTitle
      );

      if (!inputs) return;

      graphResult = {
        ...rest,
        column: selectedColumns.join(", "),
        title,
      };
    }

    if (title === "Individual Value Plot") {
      // console.log({ value: value });
      const rest = await getIndividualPlot({ value: value, header: header });

      graphResult = {
        ...rest,
        column: selectedColumns.join(", "),
        title,
      };

      // console.log(graphResult);
    }
    // console.log(title);

    if (title === "Multi Variable Histogram") {
      const rest = await getHistogramGroup(
        value,
        selectedColors,
        newTitle,
        yLabel,
        xLabel
      );

      graphResult = {
        ...rest,
        column: selectedColumns.join(", "),
        selectedColors,
        isFit,
        title,
      };
    }

    if (title === "Multi Variable Histogram (with distribution)") {
      const rest = await getHistogramGroupWithDistribution(
        value,
        selectedColors,
        newTitle,
        yLabel,
        xLabel
      );

      graphResult = {
        ...rest,
        column: selectedColumns.join(", "),
        selectedColors,
        isFit,
        title,
      };
    }

    try {
      // update analysis subcollection
      const resFromCreateAnalysis = await createAnalysis(
        token,
        documentId,
        graphResult
      );
      graphResult.id = resFromCreateAnalysis.id;
    } catch (error) {
      return console.log(error.message);
    }

    dispatch(setIsLoading()); // add dispatch here
    return closeMenu();
    // dispatch(addAnalysisAndGraphs(graphResult));
  };

  const boxPlotInputs = [];
  const boxPlotInputsGroup = [];
  const histogramInputs = [];
  for (let i = 0; i < numberOfColumns; i++) {
    boxPlotInputs.push(
      <BoxPlotVariableInput
        key={i}
        value={selectedColumns[i]}
        onChange={(e) => handleColumnSelectChange(e, i)}
        onChangeTitle={(e) => setnewTitle(e.target.value)}
        inputNumber={i}
      />
    );
  }
  for (let i = 0; i < numberOfColumns; i++) {
    boxPlotInputsGroup.push(
      <BoxPlotVariableInputGroup
        key={i}
        value={selectedColumns[i]}
        onChange={(e) => handleColumnSelectChange(e, i)}
        inputNumber={i}
      />
    );
  }

  for (let i = 0; i < numberOfColumns; i++) {
    histogramInputs.push(
      <HistogramVariableInput
        key={i}
        value={selectedColumns[i]}
        valueLegend={selectedColors[i]}
        onColorChange={(e) => handleChangeColor(e, i)}
        onChange={(e) => handleColumnSelectChange(e, i)}
        inputNumber={i}
      />
    );
  }

  return (
    <Modal open={openModal === title} onClose={handleCloseModal}>
      <Grid container sx={style}>
        <Grid
          item
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          {title === "Multi Variable Boxplot (Group)" && (
            <>
              <Grid item xs={12} sm={12} md={12}>
                <h1>{title}</h1>
              </Grid>

              <Grid item xs={6} sm={6} md={6} sx={{ mt: 0.8 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <h3> Array (Y Axis) </h3>
                    <FormControl variant="filled" fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Array (Y Axis)
                      </InputLabel>
                      <Dropdown
                        labelId="histogram-group-select-label"
                        id="histogram-group-select"
                        value={yAxis}
                        onChange={(e) => {
                          setYAxis(e.target.value);
                        }}
                        // options={options}
                      />
                    </FormControl>
                  </Grid>
                  {boxPlotInputsGroup}
                  <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                    sx={{ mt: 2 }}
                  >
                    <Grid item xs={3}>
                      <Button
                        variant="contained"
                        style={{
                          width: "auto",
                          borderRadius: "7px",
                        }}
                        onClick={addVariableInput}
                      >
                        Add Variables
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <h3>Title</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label="Title"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => {
                    setnewTitle(e.target.value);
                  }}
                />
              </Grid>
            </>
          )}

          {title === "Multi Variable Boxplot (Ungroup)" && (
            <>
              <Grid item xs={12} sm={12} md={12}>
                <h1>{title}</h1>
                <h3 style={{ marginTop: "20px" }}> Data Range</h3>
              </Grid>
              {boxPlotInputs}
            </>
          )}

          {title === "Individual Value Plot" && (
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12}>
                <h1>{title}</h1>
              </Grid>
              <Grid item xs={12}>
                <h3>Data Range</h3>
              </Grid>
              <Grid item xs={12}>
                {boxPlotInputs}
              </Grid>
              <Grid
                item
                container
                direction="column"
                alignItems="center"
                justify="center"
                sx={{ mt: 2 }}
                xs={12}
              >
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    style={{
                      width: "auto",
                      borderRadius: "7px",
                    }}
                    onClick={addVariableInput}
                  >
                    Add Variables
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}

          {title === "Multi Variable Histogram" && (
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <h1>{title}</h1>
                <h3 style={{ marginTop: "20px" }}> Data Range</h3>
              </Grid>

              {histogramInputs}

              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                sx={{ mt: 2 }}
              >
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    style={{
                      width: "auto",
                      borderRadius: "7px",
                    }}
                    onClick={addVariableInput}
                  >
                    Add Variables
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <h3>Title</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label="Title"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => {
                    setnewTitle(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <h3>X-Label</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label=" X-Label"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => setxLabel(e.target.value)}
                />
                <h3>Y-Label</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label="Y-Label"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => setyLabel(e.target.value)}
                />
              </Grid>
            </Grid>
          )}
          {title === "Multi Variable Histogram (with distribution)" && (
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <h1>{title}</h1>
                <h3 style={{ marginTop: "20px" }}> Data Range</h3>
              </Grid>

              {histogramInputs}

              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                sx={{ mt: 2 }}
              >
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    style={{
                      width: "auto",
                      borderRadius: "7px",
                    }}
                    onClick={addVariableInput}
                  >
                    Add Variables
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <h3>Title</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label="Title"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => {
                    setnewTitle(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <h3>X-Label</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label=" X-Label"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => setxLabel(e.target.value)}
                />
                <h3>Y-Label</h3>
                <TextField
                  fullWidth
                  id="filled-basic"
                  variant="filled"
                  label="Y-Label"
                  sx={{ mt: 1.8 }}
                  onChange={(e) => setyLabel(e.target.value)}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid
          item
          style={{
            display: "flex",
            float: "right",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default MultipleVariableModal;
